import PropTypes from 'prop-types';

import phrasesType from './phrases';

export const formTypeInner = {
  action: PropTypes.string.isRequired,
  errorMessages: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.string,
    ]),
  ).isRequired,
  phrases: phrasesType.isRequired,
};
const formType = PropTypes.shape(formTypeInner);

export default formType;
